// extracted by mini-css-extract-plugin
module.exports = {"gamePanel":"trivia-rumble-panel_gamePanel__ddXoq","blur":"trivia-rumble-panel_blur__t93cN"};